<template>
    <div class="container">
        <div class="searchFlex">
            <!-- 搜索框 -->
            <el-form size="mini" ref="searchform" :model="searchForm" label-width="100px" :inline="true" class="demo-form-inline" id="searchform">
                <el-form-item label="开始日期">
                    <el-date-picker v-model="searchForm.startTime"  value-format="yyyy-MM-dd" type="date" placeholder="选择开始时间"
                    :picker-options="pickerStart" > </el-date-picker>
                </el-form-item>
                <el-form-item label="委托单位">
                    <template>
                        <el-select  filterable clearable v-model="searchForm.customer" style="width: 100%"
                            placeholder="请选择委托单位">
                            <el-option v-for="item in customerList" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                <el-form-item label="提单号">
                    <el-input v-model="searchForm.blNo" clearable placeholder="请输入提单号"></el-input>
                </el-form-item>
                <el-form-item label="司机">
                    <template>
                        <el-select  filterable clearable v-model="searchForm.driverMan" style="width: 100%"
                            placeholder="请选择司机">
                            <el-option v-for="item in driverList" :key="item.no" :label="item.driverName" :value="item.driverName">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                <el-form-item label="货物名称">
                    <template>
                        <el-select  filterable clearable v-model="searchForm.goodsName" style="width: 100%"
                            placeholder="请选择货物名称">
                            <el-option v-for="item in goodsList" :key="item.id" :label="item.value"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker v-model="searchForm.endTime" value-format="yyyy-MM-dd" type="date" placeholder="选择结束时间"
                    :picker-options="pickerEnd" > </el-date-picker>
                </el-form-item>
                <el-form-item label="目的地点">
                    <template>
                        <el-select filterable clearable v-model="searchForm.endPort" style="width: 100%"
                            placeholder="请选择目的地址">
                            <el-option v-for="item in portList" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                <el-form-item label="目的详细地址">
                    <template>
                        <!-- 可选可填 -->
                        <el-select :remote-method="getAddressBy" remote filterable clearable v-model="searchForm.endAddress" style="width: 100%"
                            placeholder="请选择目的详细地址" @blur="selectBlur" @clear="selectClear">
                            <el-option v-for="item in portDetailList" :key="item.id" :label="item.address"
                                :value="item.address">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                <el-form-item label="备注信息">
                    <el-input v-model="searchForm.note" clearable placeholder="请输入备注信息"></el-input>
                </el-form-item>
                <el-form-item label="任务状态">
                    <el-select v-model="searchForm.status" clearable placeholder="请选择任务状态">
                        <el-option v-for="item in taskStatus" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务类型">
                    <el-select v-model="searchForm.taskType" clearable placeholder="请选择任务类型">
                        <el-option v-for="item in taskTypeList" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="提箱场站">
                    <el-select v-model="searchForm.station" filterable clearable placeholder="请选择提箱场站">
                        <el-option v-for="item in stationList" :key="item.id" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="实际到场时间"> 
                    <el-date-picker style="width:250px" v-model="arrivalTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" @change="getArrivalTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label=" ">
                    <div class="toolbar">
                        <el-button type="primary" size="mini" @click="addTask">新建任务</el-button>
                        <el-button type="success" size="mini" @click="getTable">查询</el-button>
                        <el-button  size="mini" @click="reset">重置</el-button>
                        <el-button type="warning" size="mini" @click="Toscreen" style="margin-left: 20px;">数据大屏</el-button>
                    </div>
                </el-form-item>
                        
            </el-form>
            <div style="margin-right:10px;">
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <div style="width: 100%;flex:1;overflow-x: auto;" >
            <vxe-table id="taskTable" :data="tasksList" border :column-config="{ resizable: true }" align="center" header-align="center" 
             :columns="columns" stripe width="100%" height="100%" :custom-config="customConfig" ref="taskTableRef"   size="mini"
             :row-config="{ isCurrent: true /* 启用当前行高亮 */ }" highlight-current-row >
             <!-- <vxe-column type="seq" width="70"></vxe-column> -->
                <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title" sortable>
                    <template #default="{ row, column }">
                        <span v-if="column.field === 'hasSubTask'"> {{ row[column.field] === 0 ? '无':'有'}} </span>
                        <span v-else-if="column.field === 'blNo'" @click="editEvent(row)"> <el-link type="primary">{{row[column.field]}}</el-link> </span>
                        <span v-else-if="column.field === 'status'" > 
                            <el-tag v-if="row[column.field]==='新建'">{{ row[column.field] }} </el-tag>
                            <el-tag v-if="row[column.field]==='发布'" type="success" > {{ row[column.field] }} </el-tag>
                            <el-tag v-if="row[column.field]==='接单'" type="warning" > {{ row[column.field] }} </el-tag>
                            <el-tag v-if="row[column.field]==='完成'" color="#ecdbf3" class="puple" > {{ row[column.field] }} </el-tag>
                            <el-tag v-if="row[column.field]==='审核'" type="info" > {{ row[column.field] }} </el-tag>
                            <el-tag v-if="row[column.field]==='退回'"  color="#E3E3E3" class="grey" > {{ row[column.field] }} </el-tag>
                            <el-tag v-if="row[column.field]==='取消'" type="danger" > {{ row[column.field] }} </el-tag>
                        </span>
                        <span v-else> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="300" align="left" fixed="right">
                    <template #default="{ row }">
                        <!-- <vxe-button mode="text" status="info" icon="vxe-icon-edit" @click="editEvent(row)">编辑</vxe-button> -->
                        <vxe-button mode="text" status="primary" icon="vxe-icon-copy" @click="copyTask(row)">复制新建</vxe-button>
                        <vxe-button mode="text" status="error" icon="vxe-icon-delete" v-if="row.status === '新建' || row.status === '退回'" @click="delTask(row)">删除</vxe-button>
                        <!-- <vxe-button v-if="row.hasSubTask === 0" mode="text" status="primary" icon="vxe-icon-add" @click="addSonTask(row)">新增子任务</vxe-button> -->
                        <vxe-button v-if="row.status === '新建' || row.status === '退回'" mode="text" status="success" icon="vxe-icon-send" @click="releaseTask(row)">发布</vxe-button>
                        <vxe-button v-if="row.status === '发布'" mode="text"  icon="vxe-icon-click-button" @click="assignTask(row)">指派</vxe-button>
                        <vxe-button v-if="row.status === '发布' || row.status === '接单'" mode="text" status="warning" icon="vxe-icon-undo" @click="withdraw(row)">撤回</vxe-button>
                    </template>
                    <!-- 配货任务 1有 -->
                </vxe-column>
            </vxe-table>
        </div>
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize"
            :total="pagination.total" @page-change="getTable">
        </vxe-pager>
        <!-- 任务编辑、新增弹窗 -->
         <task @closeDialog="closeDialog" :dialogShow="dialogShow" :dialogCode="dialogCode" :taskId="taskId" :mianTaskData="mianTaskData"
         :subTaskData="subTaskData" ></task>
        <!-- 指派司机对话框 -->
        <el-dialog v-dialogDrag title="指派司机" :visible.sync="assignShow" width="30%" :before-close="assignHandleClose">
            <div class="tiptext">请选择此任务所要指派的司机：</div>
            <el-select v-model="assignForm.driver" placeholder="请选择要指派的司机" filterable style="width: 100%;"  @change="selectDriver">
                <el-option v-for="item in freeDrivers" :key="item.no" :label="item.driverName" :value="item.driverName + '-'  + item.truckNo">
                    <span style="float: left">{{ item.driverName }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.truckNo }}</span>
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="assignHandleClose">取 消</el-button>
                <el-button type="primary" @click="assignSure">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import userProfile from '@/mixins/userProfile.js'
import task from '@/components/task.vue'
import basicData from '@/config/basicData.js'
    export default {
        name:"taskList",
        mixins: [userProfile],
        components:{
            task
        },
        data() {
            return {
                // 查询实际到场时间数组
                arrivalTime:[],
                // 分页信息
                pagination:{
                    totalPages: 0, // 总页数
                    total: 0, // 总条数
                    currentPage: 1, // 当前页数
                    pageSize: 10, // 每页显示多少条数据
                },
                searchForm:{  // 搜索框总数据
                    startTime:'',
                    endTime:'',
                    customer:'',
                    blNo:'',
                    driverMan:'',
                    status:'',
                    goodsName:'',
                    note:'',
                    endPort:'',
                    endAddress:'',
                    taskType:'',
                    station:'',
                    arrivalTimeStart:'',
                    arrivalTimeEnd:'',
                },
                taskTypeList:basicData.taskType,
                tasksList:[], // 任务列表
                taskId:'', // 编辑运输任务传递ID
                dialogShow:false, // 弹窗控制
                dialogCode:'', // 新建或编辑
                columns: [],                
                hasSubTaskStatus:[
                    {
                        value: 0,
                        label: '无'
                    }, {
                        value: 1,
                        label: '有'
                    }
                ],
                driverList:[], // 指派司机列表
                portList:[], // 地点列表
                portDetailList:[], // 详细地点列表
                goodsList:[], // 货物列表
                customerList:[], // 委托单位列表
                stationList:[], // 提箱场站列表
                taskStatus:basicData.taskStatus,
                mianTaskData:{}, // 再来一单主任务数据
                subTaskData:{}, // 再来一单子任务数据
                assignForm:{
                    taskId:'',
                    driver:'',
                    truckNo:'',
                }, // 指派表单
                assignShow:false, //  指派弹窗显示
                freeDrivers:[], // 可接单司机列表
                pickerStart:{
                    disabledDate: time => {
                    // 如果有 结束 日期 要选择结束之前的日期
                        if(this.searchForm.endTime){
                            return (
                            // 结束日期 小于 开始日期（开始日期不能选择 结束日期之后的日期）
                            new Date(this.searchForm.endTime).getTime() < time.getTime() 
                            );
                        }else{
                            // 如果没有结束日期 那么都可以选
                            return false
                        }
                    }
                },
                pickerEnd:{
                    disabledDate: time => {
                        // 如果有开始日期 
                        if(this.searchForm.startTime){
                            return (
                            // 开始日期 必须大于 结束日期（结束日期不能选择开始之前的日期） 
                            // 而 -3600*24*1000 减去 一天的时间可以选择当天日期
                            (
                                (
                                new Date(this.searchForm.startTime).getTime()
                                )-3600*24*1000
                            )
                            >
                            (time.getTime())
                            );
                        }else{
                            // 如果没有开始日期 都可以选择
                            return false
                        }
                    }
                },
            }
        },
        mounted() {
            // 获取表格信息
            this.getTable();
            this.getPort();   
            this.getGoodBy()  
            this.getdriverList() 
            this.getcustomerList()   
            this.getstationList()   
            this.getFreeDrivers()                                                                                                
        },
        methods: {
            // 重置搜索条件
            reset(){
                this.searchForm = {  // 搜索框总数据
                    startTime:'',
                    endTime:'',
                    customer:'',
                    blNo:'',
                    driverMan:'',
                    status:'',
                    goodsName:'',
                    note:'',
                    endPort:'',
                    arrivalTimeStart:'',
                    arrivalTimeEnd:'',
                }
                this.arrivalTime = []
            },
            // 获取空闲司机
            getFreeDrivers() { 
                this.$api.getFreeDrivers( '' ).then(res =>{
                    this.freeDrivers = res;
                })
            },
            // 选择空闲司机
            selectDriver(data){
                 const dataList = data.split('-')
                this.assignForm.driver = dataList[0]
                this.assignForm.truckNo = dataList[1]
            },
            // 获取表格信息
            getTable() {
                this.$api.getCarList( this.pagination.currentPage, this.pagination.pageSize, this.searchForm ).then(res =>{
                    this.columns = res.columns;
                    this.tasksList = res.tableData;
                    this.pagination.total = res.total;
                })
            },
            // 查询地址
            getPort() {
                this.$api.getDicList( { value:'陆运站点'} ).then(res =>{
                    this.portList = res
                })
            },
            // 查询详细地址
            getAddressBy(data) {
                this.$api.getAddressBy( data ).then(res =>{
                    this.portDetailList = res
                })
            },
            // 详细目的地址可选可填，填写时
            selectBlur(e) {
                if (e.target.value !== '') {
                    this.searchForm.endAddress = e.target.value;
                    this.$forceUpdate();   // 强制更新
                }
            },
            // 根据货物名称查询货物
            getGoodBy() {
                this.$api.getDicList( { value:'货物名称'} ).then(res =>{
                    this.goodsList = res
                })
            },
            // 清空详细地址
            selectClear() {
                this.searchForm.endAddress = '';
                this.$forceUpdate();
            },
            // 获取委托列表
            getcustomerList(){
                this.$api.getDicList( { value:'委托单位'} ).then(res =>{
                    this.customerList = res
                })
            },
            // 获取提箱场站
            getstationList(){
                this.$api.getDicList( { value:'场站'} ).then(res =>{
                    this.stationList = res
                })
            },
            // 新建主任务
            addTask(){
                this.dialogShow = true;
                this.dialogCode = 'add';
                this.taskId = '';
                this.mianTaskData = {}
                this.subTaskData = {}
            },
            // 编辑任务
            editEvent(data){
                this.dialogShow = true;
                this.dialogCode = 'edit';
                this.taskId = data.id;
                this.mianTaskData = {}
                this.subTaskData = {}
            },
            // 删除主任务
            delTask(data){
                this.$confirm('是否要删除本任务？删除后将同时清空主任务和子任务的费用明细。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    distinguishCancelAndClose: true,  // 关键配置：区分叉号和取消按钮
                    closeOnClickModal: false          // 禁止点击遮罩层关闭
                    })
                    .then(() => {
                        this.$api.cancelTask( data.id ).then(res =>{
                            this.$message({
                                type: "success",
                                message: '删除成功'
                            })
                            this.getTable()
                        })
                    })
                    .catch(action => {
                    if (action === 'cancel') {
                        // 取消按钮逻辑
                        console.log('取消操作');
                    } else if (action === 'close') {
                        // 叉号关闭逻辑（可空置或自定义）
                        console.log('取消操作');
                    }
                });

            },
            async closeDialog(data,status){
                this.dialogShow = data;
                this.mianTaskData = {}
                this.subTaskData = {}
                // await this.reset()
                if(status === '新建' || status === '发布' || status === '退回'){
                    await this.getTable()
                }
            },
            // 发布任务
            releaseTask(data){
                this.$confirm('确定发布此任务吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    distinguishCancelAndClose: true,  // 关键配置：区分叉号和取消按钮
                    closeOnClickModal: false          // 禁止点击遮罩层关闭
                    })
                    .then(() => {
                        this.$api.publishTask( data.id ).then(res =>{
                            this.$message({
                                type: "success",
                                message: '发布成功'
                            })
                            this.getTable()
                        })
                    })
                    .catch(action => {
                    if (action === 'cancel') {
                        // 取消按钮逻辑
                        console.log('取消操作');
                    } else if (action === 'close') {
                        // 叉号关闭逻辑（可空置或自定义）
                        console.log('取消操作');
                    }
                });
            },
            // 撤回任务
            withdraw(data){
                this.$confirm('确定撤回此任务吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    distinguishCancelAndClose: true,  // 关键配置：区分叉号和取消按钮
                    closeOnClickModal: false          // 禁止点击遮罩层关闭
                })
                .then(() => {
                    this.$api.undoTask( data.id ).then(res =>{
                        this.$message({
                            type: "success",
                            message: '撤回成功'
                        })
                        this.getTable()
                    })
                })
                .catch(action => {
                    if (action === 'cancel') {
                        // 取消按钮逻辑
                        console.log('取消操作');
                    } else if (action === 'close') {
                        // 叉号关闭逻辑（可空置或自定义）
                        console.log('取消操作');
                    }
                });
            },
            // 指派任务
            assignTask(data){
                this.assignForm.taskId = data.id
                this.assignShow = true
                this.getFreeDrivers()
            },
            // 获取指派任务司机
            getdriverList(){
                this.$api.getDriverByName( '' ).then(res =>{
                    this.driverList = res.tableData
                })
            },
            // 关闭指派司机弹窗
            assignHandleClose(){
                this.assignForm = {
                    taskId:'',
                    driver:'',
                    truckNo:'',
                }
                this.assignShow = false  
            },
            // 指派司机
            assignSure(){
                if(this.assignForm.driver === ''){
                    this.$message({
                        type: "error",
                        message: '请选择要指派的司机'
                    })
                }else{
                    this.$api.assignedTask( this.assignForm.taskId, this.assignForm.driver, this.assignForm.truckNo ).then(res =>{
                        this.$message({
                            type: "success",
                            message: '指派成功'
                        })
                        this.assignHandleClose()
                        this.getTable()
                    })
                }
            },
            // 选择实际到场时间
            getArrivalTime(data){
                if(data === null){
                    this.searchForm.arrivalTimeStart = ''
                    this.searchForm.arrivalTimeEnd = ''
                }else{
                    this.searchForm.arrivalTimeStart = data[0] + ' 00:00:00'
                    this.searchForm.arrivalTimeEnd = data[1]+ ' 00:00:00'
                }
            },
            async copyTask(data){
                // 查子任务数据
                const taskData =  JSON.parse(JSON.stringify(data))
                // 如果hasSubTask = 1，有子任务，查询任务详情，=0，直接复制主任务
                if(data.hasSubTask === 1){
                    await this.$api.getCarTaskDetail( data.id ).then(res =>{
                    const subtaskData =  JSON.parse(JSON.stringify(res.subTask))
                        delete subtaskData.status
                        delete subtaskData.createMan
                        delete subtaskData.createTime
                        delete subtaskData.arrivalTime
                        delete subtaskData.hasSubTask
                        delete subtaskData.isDelete
                        delete subtaskData.no
                        delete subtaskData.id
                        this.subTaskData = subtaskData;
                    })
                }
                // 复制时删掉任务状态status、发布人createMan、发布时间createTime、任务完成时间arrivalTime、任务id、_X_ROW_KEY、no、isDelete、hasSubTask
                delete taskData.status;
                delete taskData.createMan;
                delete taskData.createTime;
                delete taskData.arrivalTime;
                delete taskData.id;
                delete taskData._X_ROW_KEY;
                delete taskData.no;
                delete taskData.isDelete;
                delete taskData.hasSubTask;
                delete taskData.driverMan;
                delete taskData.truckNo;
                this.dialogShow = true;
                this.dialogCode = 'add';
                this.taskId = '';
                this.mianTaskData = taskData;
            },
            Toscreen(){
                const routeData = {
                    name: 'screen',
                };
                // 生成完整的路由对象
                const resolvedRoute = this.$router.resolve(routeData);
                // 打开新窗口并导航至生成的URL
                window.open(resolvedRoute.href, '_blank');
            },
        }
    }
</script>

<style lang="css" scoped>
.container{
    width: 100%;
    height: calc(100vh - 84px);
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
}
.searchFlex{
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items:flex-end;
}
.toolbar{
    display: inline-block;
    margin-left:20px;
    width: 340px;
    margin-right: 10px;
}
.tiptext{
    font-size: 16px;
    margin-bottom: 10px;
}
.puple{
    color: rgb(149, 90, 156);
    border-color: #ecdbf3;
}
.grey{
    color: rgb(153, 153, 153);
    border-color: #e6e6e6;
}
/* .vxe-toolbar {
    padding:0px !important;
} */
::v-deep .el-form-item {
    margin-bottom: 15px;
}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 178px;
}
::v-deep .el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
    width: 178px;
}
::v-deep .el-dialog__body {
    padding-top: 10px !important;
}
::v-deep .vxe-table--render-default .vxe-body--row.row--current {
    /* background-color: #8adeffad; */
}
#searchform .el-form-item {
    margin-bottom: 5px !important;
}
</style>